import { ListenableSubscribable } from '@benzinga/subscribable';
import { deepEqual } from '@benzinga/utils';
import { CategoriesAlert } from './entities';

interface CategoriesAlertsUpdatedEvent {
  categoriesAlerts: CategoriesAlert[];
  type: 'categories_alerts_updated';
}

export type NewsAlertsStoreEvent = CategoriesAlertsUpdatedEvent;

export class NewsAlertsStore extends ListenableSubscribable<NewsAlertsStoreEvent> {
  private date?: Date;
  private categoriesAlerts?: CategoriesAlert[];

  public shouldWeFetchAlerts = (): boolean => {
    const ONE_MIN = 60 * 1000; /* ms */
    const lastCalled = this.date?.getTime() ?? 0; // use this once all watchlist are grabbed from manager
    if (this.categoriesAlerts === undefined || Date.now() - lastCalled > ONE_MIN) {
      return true;
    }
    return false;
  };

  public getCategoriesAlerts = (): CategoriesAlert[] | undefined => {
    return this.categoriesAlerts;
  };

  public setCategoriesAlerts = (categoriesAlerts: CategoriesAlert[]): void => {
    this.date = new Date();
    if (deepEqual(this.categoriesAlerts, categoriesAlerts) === false) {
      this.categoriesAlerts = categoriesAlerts;
      this.dispatch({
        categoriesAlerts: categoriesAlerts,
        type: 'categories_alerts_updated',
      });
    }
  };

  public clearCategoriesAlerts = (): void => {
    this.categoriesAlerts = undefined;
    this.date = undefined;
    this.dispatch({
      categoriesAlerts: [],
      type: 'categories_alerts_updated',
    });
  };
}
